import { Stack, Typography } from '@mui/material';
import { NoDataFound2 } from 'Components/NoDataFound2';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop, useDictionary } from 'Hooks';

export const NoDocumentsFound = () => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Documents);
  const redirects = [
    {
      href: process.env.REACT_APP_MOD_URL + 'allApplies',
      text: dictionary.document.noDocumentsOffer1,
    },
    {
      href: process.env.REACT_APP_MOD_URL + 'medicalConfirmed',
      text: dictionary.document.noDocumentsOffer2,
    },
    {
      href: process.env.REACT_APP_REDIRECT_URL + 'personal-team',
      text: dictionary.document.noDocumentsOffer3,
    },
  ];

  return (
    <NoDataFound2
      gap={isDesktop ? '48px' : '32px'}
      redirects={redirects}
      headerComponent={
        <Stack gap='16px' alignItems={'center'} padding={'20px'}>
          <Typography
            variant='h2'
            color='text.secondary'
            alignSelf={isDesktop ? 'center' : 'flex-start'}
          >
            {dictionary.title}
          </Typography>
          <Stack
            justifyContent={'center'}
            direction={isDesktop ? 'row' : 'column'}
            marginBottom={isDesktop ? '20px' : undefined}
          >
            <Typography
              variant='body1'
              color='text.secondary'
              marginRight={'5px'}
            >
              {dictionary.document.noDocumentsTitle}
            </Typography>
            <Typography variant={'body3'} color='text.secondary'>
              {dictionary.document.noDocumentsSubtitle}
            </Typography>
          </Stack>
        </Stack>
      }
    />
  );
};
